/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * This class provides a mapping between the error code returned from HTTP request
 * in Startingpoint and the Explore product internal error code
 */
import SmartsRecommenderStatus from 'util/SmartsRecommenderStatus';
import ExploreErrors from './ExploreError';
const ERRORS_MAPPING = 	[
	{
		REQUEST_ERROR_CODE : SmartsRecommenderStatus.NOT_JOINED_ERROR,
		EXPLORE_ERROR_CODE : 'REL_002'
	},
	{
		REQUEST_ERROR_CODE : 'CQE-801',
		EXPLORE_ERROR_CODE : 'REL_001'
	},
	{
		REQUEST_ERROR_CODE : 'ABANDONED_RELATIONSHIP_REQUEST', //abandoned Request Error
		EXPLORE_ERROR_CODE : 'REL_003'
	}
];

class StartingPointsError {
	/**
	 * Return the interal ExploreError Object for the given HTTP Request Service Error Code
	 */
	static getErrorObject(requstErrorCode){
		const result = ERRORS_MAPPING.find(entry=> entry.REQUEST_ERROR_CODE === requstErrorCode);
		if(result){
			return new ExploreErrors(result.EXPLORE_ERROR_CODE);
		}
		return null; //All known HTTP errors should be handled in Explore
	}
}

export default StartingPointsError;



// WEBPACK FOOTER //
// ./src/js/util/StartingPointsRequestError.js